<template>
  <div class="share-package-settings m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Document Packages</h5>
      <b-button
        class="pt-2 pb-2"
        size="sm"
        variant="primary"
        @click="addSharePackage"
        >New</b-button
      >
    </div>
    <grid
      ref="grid"
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="sharePackages"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="false"
    />
    <b-modal
      centered
      ref="form-modal"
      :title="(formId ? 'Edit ' : 'Add ') + 'document package'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok.prevent="submitSharePackage"
      no-close-on-backdrop
      header-class="bg-purple"
      size="lg"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-row
        ><b-col cols="6"
          ><b-form-group
            label="Name"
            :state="formErrors.name.length == 0 ? null : false"
            :invalid-feedback="formErrors.name.join(', ')"
          >
            <b-form-input
              v-model="form.name"
              :state="formErrors.name.length == 0 ? null : false"
              maxLength="100"
            ></b-form-input> </b-form-group></b-col
      ></b-row>

      <b-row>
        <b-col>
          <b-form-group label="One-time-share documents">
            <template v-slot:label="">
              <div class="d-flex justify-content-between">
                <div>One-time-share documents</div>
                <div>
                  <b-button
                    class="pt-2 pb-2"
                    size="sm"
                    variant="primary"
                    @click="addForm"
                    >New</b-button
                  >
                </div>
              </div>
            </template>
            <grid
              ref="gridForm"
              :groupFeature="false"
              :columns="formColumns"
              :autoHeight="true"
              :data="formItems"
              :columnLines="false"
              :searchFeature="true"
              :stripeFeature="false"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label="Recurrent documents">
            <template v-slot:label="">
              <div class="d-flex justify-content-between">
                <div>Recurrent documents</div>
                <div>
                  <b-button
                    class="pt-2 pb-2"
                    size="sm"
                    variant="primary"
                    @click="addRecurrentForm"
                    >New</b-button
                  >
                </div>
              </div>
            </template>
            <grid
              ref="gridRecurrentForm"
              :groupFeature="false"
              :columns="recurrentFormColumns"
              :autoHeight="true"
              :data="recurrentFormItems"
              :columnLines="false"
              :searchFeature="true"
              :stripeFeature="false"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      centered
      ref="form-form-modal"
      title="Add One-time-share document"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok.prevent="submitForm"
      no-close-on-backdrop
      header-class="bg-purple"
      size="md"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-row>
        <b-col>
          <b-form-group
            label="Form"
            :state="formFormErrors.form.length == 0 ? null : false"
            :invalid-feedback="formFormErrors.form.join(', ')"
          >
            <v-select v-model="formForm.form" :options="formOptions"></v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      centered
      ref="form-recurrent-form-modal"
      title="Add recurrent document"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok.prevent="submitRecurrentForm"
      no-close-on-backdrop
      header-class="bg-purple"
      size="md"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <b-row>
        <b-col>
          <b-form-group
            label="Form"
            :state="formRecurrentFormErrors.form.length == 0 ? null : false"
            :invalid-feedback="formRecurrentFormErrors.form.join(', ')"
          >
            <v-select
              v-model="formRecurrentForm.form"
              :options="formOptions"
            ></v-select>
          </b-form-group>
          <b-form-group>
            <recurrence-control
              :startDate="startDateTime"
              v-model="formRecurrentForm.recurrence"
              :formErrors="formRecurrentFormErrors.recurrence"
              :maxOccurrences="50"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import sharePackageServer from "../../server/sharePackage";
import { mapActions, mapState } from "vuex";
import { validateRequired } from "../../helpers/validation";
import { frequencies, daysIntervals } from "../../config/medications";
import RecurrenceControl from "../controls/RecurrenceControl";

export default {
  name: "SharePackageCrud",
  components: {
    Grid,
    RecurrenceControl
  },
  data() {
    return {
      formId: null,
      form: {
        name: "",
        forms: [],
        recurrentForms: []
      },
      formErrors: {
        name: [],
        forms: [],
        recurrentForms: []
      },
      formFormId: null,
      formForm: {
        form: null
      },
      formFormErrors: {
        form: []
      },
      formRecurrentFormId: null,
      formRecurrentForm: {
        form: null,
        recurrence: {
          frequencyNumber: 1,
          frequencyUnit: "Days",
          monthlyRepeat: null,
          endType: "ByOccurrences",
          endDate: null,
          occurrences: 10,
          sunday: false,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false
        }
      },
      formRecurrentFormErrors: {
        form: [],
        frequencyId: [],
        daysIntervalId: [],
        recurrence: {
          ends: [],
          weekDay: []
        }
      }
    };
  },
  mounted() {
    this.fetchSharePackages();
    this.fetchFormBuilderForms({ category: "main" });
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("client", ["fetchSharePackages"]),
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    validateSharePackageSubmit() {
      let withoutErrors = true;

      this.formErrors.name = [];
      if (!validateRequired(this.form.name)) {
        this.formErrors.name.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitSharePackage() {
      const result = this.validateSharePackageSubmit();
      if (result) {
        const formData = {
          name: this.form.name,
          formIds: this.form.forms.map(form => form.form.value),
          recurrentForms: this.form.recurrentForms.map(recurrentForm => {
            return {
              formId: recurrentForm.form.value,
              recurrence: recurrentForm.recurrence
            };
          })
        };
        if (this.formId) {
          await sharePackageServer.update(this.formId, formData);
        } else {
          await sharePackageServer.create(formData);
        }
        this.fetchSharePackages();
        this.showAlertSuccess();
        this.$refs["form-modal"].hide();
      }
    },
    addSharePackage() {
      this.formId = null;
      this.form = {
        name: "",
        forms: [],
        recurrentForms: []
      };
      this.formErrors = {
        name: [],
        forms: [],
        recurrentForms: []
      };
      this.$refs["form-modal"].show();
    },
    clearErrors() {
      this.formFormErrors = {
        form: []
      };
      this.formRecurrentFormErrors = {
        form: [],
        recurrence: {
          ends: [],
          weekDay: []
        }
      };
    },
    addForm() {
      this.formFormId = null;
      this.formForm = {
        form: null
      };
      this.clearErrors();
      this.$refs["form-form-modal"].show();
    },
    addRecurrentForm() {
      this.formRecurrentFormId = null;
      this.formRecurrentForm = {
        form: null,
        recurrence: {
          frequencyNumber: 1,
          frequencyUnit: "Days",
          monthlyRepeat: null,
          endType: "ByOccurrences",
          endDate: null,
          occurrences: 10,
          sunday: false,
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false
        }
      };
      this.clearErrors();
      this.$refs["form-recurrent-form-modal"].show();
    },
    validateFormSubmit() {
      let withoutErrors = true;

      this.formFormErrors.form = [];
      if (!validateRequired(this.formForm.form)) {
        this.formFormErrors.form.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitForm() {
      const result = await this.validateFormSubmit();
      if (result) {
        if (this.formFormId) {
          const index = this.form.forms.findIndex(
            form => form.formIndex == this.formForm.formIndex
          );
          this.form.forms.splice(index, 1, {
            id: this.formFormId,
            ...this.formForm
          });
        } else {
          this.form.forms.push({
            ...this.formForm,
            formIndex: this.form.forms.length
          });
        }

        this.$refs["form-form-modal"].hide();
      }
    },
    validateRecurrentFormSubmit() {
      let withoutErrors = true;

      this.formRecurrentFormErrors.form = [];
      if (!validateRequired(this.formRecurrentForm.form)) {
        this.formRecurrentFormErrors.form.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitRecurrentForm() {
      const result = await this.validateRecurrentFormSubmit();
      if (result) {
        if (this.formRecurrentFormId) {
          const index = this.form.recurrentForms.findIndex(
            recurrentForm =>
              recurrentForm.formIndex == this.formRecurrentForm.formIndex
          );
          this.form.recurrentForms.splice(index, 1, {
            id: this.formRecurrentFormId,
            ...this.formRecurrentForm
          });
        } else {
          this.form.recurrentForms.push({
            ...this.formRecurrentForm,
            formIndex: this.form.recurrentForms.length
          });
        }

        this.$refs["form-recurrent-form-modal"].hide();
      }
    },
    getDaysIntervalId(intervalLabel, intervalAmount) {
      switch (`${intervalAmount}${intervalLabel}`) {
        case "2Days":
          return "every2Days";
        case "3Days":
          return "every3Days";
        case "1Weeks":
          return "1timePerWeek";
        case "2Weeks":
          return "everyTwoWeeks";
        case "3Weeks":
          return "every3Weeks";
        case "28Days":
          return "every28Days";
        case "30Days":
          return "every30Days";

        default:
          return null;
      }
    },
    toIntervalAmounts(recurrentForm) {
      switch (recurrentForm.daysIntervalId) {
        case "every2Days":
          return {
            frequency: "Days",
            amount: 2
          };
        case "every3Days":
          return {
            frequency: "Days",
            amount: 3
          };
        case "1timePerWeek":
          return {
            frequency: "Weeks",
            amount: 1
          };
        case "everyTwoWeeks":
          return {
            frequency: "Weeks",
            amount: 2
          };
        case "every3Weeks":
          return {
            frequency: "Weeks",
            amount: 3
          };
        case "every28Days":
          return {
            frequency: "Days",
            amount: 28
          };
        case "every30Days":
          return {
            frequency: "Days",
            amount: 30
          };

        default:
          return {
            frequency: "Days",
            amount: 1
          };
      }
    }
  },
  computed: {
    ...mapState("client", {
      sharePackages: state => state.sharePackages
    }),
    ...mapState("formBuilder", {
      allForms: state => state.list
    }),
    formOptions() {
      return this.allForms["main"].map(form => ({
        value: form.id,
        label: form.name
      }));
    },
    columns() {
      let columns = [
        {
          text: "Name",
          field: "name",
          flex: 1,
          editor: false
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: 70,
          actions: [
            {
              tooltip: "Edit",
              renderer: () =>
                `<img class="b-action-item" src="${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`,
              onClick: async ({ record }) => {
                this.formId = record.id;
                this.form = {
                  name: record.data.name,
                  forms: record.data.forms.map((form, formIndex) => {
                    return {
                      formIndex,
                      form: form.form
                        ? {
                            value: form.form.id,
                            label: form.form.name
                          }
                        : null
                    };
                  }),
                  recurrentForms: record.data.recurrentForms.map(
                    (form, formIndex) => {
                      return {
                        formIndex,
                        form: form.form
                          ? {
                              value: form.form.id,
                              label: form.form.name
                            }
                          : null,
                        recurrence: {
                          frequencyNumber: form.frequencyNumber,
                          frequencyUnit: form.frequencyUnit,
                          monthlyRepeat: form.monthlyRepeat,
                          endType: form.endType,
                          endDate: form.endDate,
                          occurrences: form.occurrences,
                          sunday: form.sunday,
                          monday: form.monday,
                          tuesday: form.tuesday,
                          wednesday: form.wednesday,
                          thursday: form.thursday,
                          friday: form.friday,
                          saturday: form.saturday
                        }
                      };
                    }
                  )
                };
                this.formErrors = {
                  name: [],
                  forms: [],
                  recurrentForms: []
                };
                this.$refs["form-modal"].show();
              }
            },
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item ml-2 mr-1" src="${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    await sharePackageServer.delete(record.id);
                    this.fetchSharePackages();
                    this.showAlertSuccess();
                  })
                  .catch(function() {});
              }
            }
          ]
        }
      ];
      return columns;
    },
    formItems() {
      return this.form.forms.map(item => {
        return {
          ...item
        };
      });
    },
    formColumns() {
      return [
        {
          text: "Form",
          field: "form",
          flex: 1,
          editor: false,
          type: "template",
          template: data => {
            return `<div class="text-wrap">${data.record.data.form.label}</div>`;
          },
          sortable: false
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: 80,
          actions: [
            {
              tooltip: "Edit",
              renderer: () =>
                `<img class="b-action-item" src="${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`,
              onClick: async ({ record }) => {
                this.formFormId = record.data.id;
                this.formForm = {
                  ...record.data
                };
                this.clearErrors();
                this.$refs["form-form-modal"].show();
              }
            },
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item ml-2 mr-1" src="${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    var index = record.data.formIndex;
                    this.form.forms.splice(record.data.formIndex, 1);
                    for (var i = index; i < this.form.forms.length; i++) {
                      this.form.forms[i].formIndex = i;
                    }
                  })
                  .catch(function() {});
              }
            }
          ]
        }
      ];
    },
    recurrentFormItems() {
      return this.form.recurrentForms.map(item => {
        return {
          ...item
        };
      });
    },
    recurrentFormColumns() {
      return [
        {
          text: "Form",
          field: "form",
          flex: 1,
          editor: false,
          type: "template",
          template: data => {
            return `<div class="text-wrap">${data.record.data.form.label}</div>`;
          },
          sortable: false
        },
        {
          text: "Frequency",
          field: "frequency",
          editor: false,
          type: "template",
          flex: 1,
          template: ({ record }) => {
            let result = `Repeat every ${record.data.recurrence.frequencyNumber} ${record.data.recurrence.frequencyUnit}`;

            if (record.data.recurrence.frequencyUnit == "Weeks") {
              result +=
                " on " +
                [
                  ...(record.data.recurrence.sunday ? ["Sunday"] : []),
                  ...(record.data.recurrence.monday ? ["Monday"] : []),
                  ...(record.data.recurrence.tuesday ? ["Tuesday"] : []),
                  ...(record.data.recurrence.wednesday ? ["Wednesday"] : []),
                  ...(record.data.recurrence.thursday ? ["Thursday"] : []),
                  ...(record.data.recurrence.friday ? ["Friday"] : []),
                  ...(record.data.recurrence.saturday ? ["Saturday"] : [])
                ].join(", ");
            }

            return result;
          },
          sortable: false
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: 80,
          actions: [
            {
              tooltip: "Edit",
              renderer: () =>
                `<img class="b-action-item" src="${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`,
              onClick: async ({ record }) => {
                this.formRecurrentFormId = record.data.id;
                this.formRecurrentForm = {
                  ...record.data
                };
                this.clearErrors();
                this.$refs["form-recurrent-form-modal"].show();
              }
            },
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item ml-2 mr-1" src="${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    var index = record.data.formIndex;
                    this.form.recurrentForms.splice(record.data.formIndex, 1);
                    for (
                      var i = index;
                      i < this.form.recurrentForms.length;
                      i++
                    ) {
                      this.form.recurrentForms[i].formIndex = i;
                    }
                  })
                  .catch(function() {});
              }
            }
          ]
        }
      ];
    },
    frequencyOptions() {
      return Object.values(frequencies).map(f => ({
        value: f.key,
        label: f.label
      }));
    },
    recurrentFormFrequency: {
      get() {
        return this.formRecurrentForm.frequencyId
          ? this.frequencyOptions.find(
              frequency => frequency.value == this.formRecurrentForm.frequencyId
            )
          : null;
      },
      set(newValue) {
        this.formRecurrentForm.frequencyId = newValue ? newValue.value : null;
      }
    },
    daysIntervalOptions() {
      return Object.values(daysIntervals).map(d => ({
        value: d.key,
        label: d.label
      }));
    },
    daysInterval: {
      get() {
        return this.formRecurrentForm.daysIntervalId
          ? this.daysIntervalOptions.find(
              daysInterval =>
                daysInterval.value == this.formRecurrentForm.daysIntervalId
            )
          : null;
      },
      set(newValue) {
        this.formRecurrentForm.daysIntervalId = newValue
          ? newValue.value
          : null;
      }
    },
    startDateTime() {
      return this.formatDateTimeSql(this.getCurrentAdjustedDateTime());
    }
  }
};
</script>
<style scoped>
.times-container {
  height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
